//海地克里奥尔语 - 检测到的语言
export default {
    common: {
        notshow: 'Pa montre jodi a',
        unit: 'USDT',
        day: 'Jou',
        week: 'Semèn',
        save: 'Sove',
        submit: 'Soumèt',
        confirmtitle: 'Konfime Operasyon',
        confirm: 'Konfime',
        reset: 'Reyajiste',
        refresh: 'Aktyalize',
        copy: 'Kopye',
        copysuccessful: 'Kopye Avèk Siksè',
        modify: 'Modifye',
        binding: 'Konekte',
        finished: 'Konplete',
        canceled: 'Anile',
        cancel: 'Anile',
        all: 'Tout',
        back: 'Retounen',
        loading: 'Chajman...',
        nomore: 'Tout Dosye',
        errortxt: 'Chajman Echwe',
        loosing: 'Lage pou aktyalize...',
        pulling: 'Rale anba pou aktyalize...',
        nodata: 'Pa gen dosye ankò',
        buy: 'Achte',
        buyup: 'Achte Monte',
        buydown: 'Achte Desann',
        sell: 'Vann',
        forserver: 'Kontakte Sèvis Kliyan',
        total: 'Total',
        status1: 'Annatant Revizyon',
        status2: 'Konplete',
        status3: 'Rejte',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Transfè Bank'
    },
    footer: {
        home: 'Akèy',
        market: 'Mache',
        exchange: 'Echanj',
        options: 'Opsyon',
        assets: 'Byen',
        change: 'Transfè',
        recharge: 'Depo',
        withdrawal: 'Retrè'
    },
    home: {
        menu1: 'Komès Opsyon',
        menu1desc: 'Sipòte BTC/USDT elatriye',
        menu2: 'Depo Rapid',
        menu3: 'Retrè',
        menu4: 'Sipò Anliy',
        menu5: 'Echanj Rapid',
        menu6: 'Prè',
        menu7: 'Mining Staking',
        menu8: 'Garanti',
        menu9: 'Transfè Kont',
        ranktitle: 'Lis Ogmantasyon',
        name: 'Non',
        price: 'Dènye Pri',
        risefall: 'Chanjman %'
    },
    register: {
        register: 'Enskri',
        login: 'Konekte',
        email: 'Imèl',
        phone: 'Telefòn',
        accountplaceholder: 'Antre kont',
        emailplaceholder: 'Antre imèl',
        phoneplaceholder: 'Antre nimewo telefòn',
        pwdplaceholder: 'Antre modpas',
        pwdplaceholder1: 'Modpas dwe 6-20 karaktè',
        agepwdplaceholder: 'Konfime modpas',
        agepwdplaceholder1: 'Modpas yo pa menm',
        invitecodeplaceholder: 'Antre kòd envitasyon',
        remember: 'Sonje modpas',
        fotget: 'Bliye modpas'
    },
    market: {
        title: 'Mache',
        all: 'Tout'
    },
    member: {
        reputation: 'Nòt Kredi',
        identity_authentication: 'Verifikasyon Idantite',
        under_review: 'Anba Revizyon',
        certified: 'Verifye',
        awaiting_certification: 'Annatant Verifikasyon',
        binding_withdrawal_address: 'Konekte Adrès Retrè',
        currently_selected_currency: 'Lajan Kouran',
        withdrawal_address: 'Adrès Retrè',
        sharing_link: 'Lyen Pataj Mwen',
        my_promotion_code: 'Kòd Referans Mwen',
        promotion_code: 'Kòd Referans',
        system_message: 'Mesaj Sistèm',
        night_mode: 'Mòd Nwit',
        security_center: 'Sant Sekirite',
        seted: 'Konfigire',
        noset: 'Pa Konfigire',
        login_password: 'Modpas Koneksyon',
        transaction_password: 'Modpas Tranzaksyon',
        app_download: 'Telechaje App',
        log_out: 'Dekonekte',
        aboutus: 'Entwodiksyon sit entènèt'
    },
    identity: {
        title: 'Verifikasyon Idantite',
        name: 'Non',
        nameplaceholder: 'Antre vrè non',
        uploader: 'Chaje Foto ID',
        tip1: 'Chaje Devan ID',
        tip2: 'Chaje Dèyè ID'
    },
    address: {
        title: 'Konekte Adrès Retrè',
        bType: 'Lajan Kouran',
        address: 'Adrès Retrè',
        addressplaceholder: 'Antre adrès retrè'
    },
    security: {
        title: 'Sant Sekirite',
        modifypwd: 'Modpas Koneksyon',
        resetlegalpwd: 'Modpas Tranzaksyon',
        loginpwd: 'Nouvo Modpas Koneksyon',
        pwdage: 'Konfime Modpas',
        loginpwdplaceholder: 'Antre modpas koneksyon kouran',
        loginnewpwdplaceholder: 'Antre nouvo modpas koneksyon',
        moneypwd: 'Antre modpas tranzaksyon',
        pwdageplaceholder: 'Konfime modpas ankò'
    },
    trade: {
        title: 'Komès Echanj',
        price: 'Pri',
        num: 'Kantite',
        entrust: 'Lòd Kouran',
        clinch: 'Komès Konplete',
        used: 'Disponib',
        buyed: 'Kapab Achte',
        amount: 'Kantite Komès',
        limitprice: 'Pri Limit',
        marketprice: 'Pri Mache',
        forprice: 'Komès nan pi bon pri kouran',
        errorMoney: 'Balans ensifizan',
        priceerror: 'Antre pri lòd',
        numerror: 'Antre kantite lòd',
        moneyerror: 'Antre valè lòd'
    },
    assets: {
        allconvert: 'Total Valè Byen',
        usenum: 'Disponib',
        freeze: 'Bloke',
        convert: 'Konvèti',
        tab1: 'Byen',
        tab11: 'Total Valè Byen',
        tab12: 'Valè Opsyon',
        tab13: 'Valè Fon',
        tab14: 'Valè Kantitativ',
        tab2: 'Opsyon',
        tab21: 'Kont Opsyon',
        tab3: 'Fon',
        tab31: 'Kont Fon',
        tab4: 'Kantitativ',
        tab41: 'Kont Kantitativ',
        tbhead1: 'Dosye Finansye',
        tbhead2: 'Dosye Retrè',
        tbhead3: 'Dosye Depo',
        tbhead4: 'Dosye Transfè',
        rcdnum: 'Kantite',
        rcd: 'Dosye',
        rcdtime: 'Tan',
        rcdstatus: 'Estati',
        rcddesc: 'Remak',
        rcdaddress: 'Adrès Depo'
    },
    change: {
        title: 'Transfè',
        from: 'Soti nan {name}',
        to: 'Ale nan {name}',
        frmtitle: 'Kantite Transfè',
        inputplaceholder: 'Antre kantite transfè',
        btntxt: 'Transfè'
    },
    recharge: {
        title: 'Depo',
        bType: 'Lajan Kouran',
        address: 'Adrès Depo',
        token: 'Prèv Peman',
        tokenplaceholder: 'Chaje prèv peman',
        num: 'Kantite Depo',
        numplaceholder: 'Antre kantite',
        btn: 'Soumèt pou Revizyon',
        bankname: 'Non Bank',
        bankno: 'Nimewo Bank',
        accountname: 'Non Kont',
        bankaddress: 'Adrès Bank',
        bankcode: 'Kòd Transfè Bank',
        companyaddress: 'Adrès Konpayi'
    },
    withdrawal: {
        title: 'Retrè',
        frmtitle1: 'Kantite',
        frmplaceholder1: 'Kantite retrè ant {min} - {max}',
        frmtitle2: 'Modpas Tranzaksyon',
        frmplaceholder2: 'Antre modpas tranzaksyon',
        getnum: 'Kantite Resevwa',
        fee: 'Frè',
        btn: 'Retrè'
    },
    exchangeb: {
        title: 'Echanj',
        account: 'Kont',
        btn: 'Echanj',
        numerror: 'Antre kantite echanj'
    },
    option: {
        title: 'Opsyon',
        typetitle: 'Kontra Segonn',
        listtitle: 'Pozisyon',
        kline: 'Liy-K',
        high: 'Wo',
        low: 'Ba',
        nums: 'Vol 24È',
        time: 'Tan',
        transaction: 'Mòd Komès',
        quantity: 'Gwosè Pozisyon',
        quantityerror: 'Antre gwosè pozisyon',
        times: 'Tan Ouvèti',
        times1: 'Tan Règleman',
        account: 'Balans Kont',
        buyup: 'Achte Monte',
        buydown: 'Achte Desann',
        tab1: 'Lis Pozisyon',
        tab2: 'Istwa Lòd',
        num: 'Kantite',
        price1: 'Pri Achte',
        price2: 'Pri Règleman',
        profitandloss: 'Estimasyon P/P',
        profitandloss1: 'P/P',
        countdown: 'Kontaj Desandan',
        waitfinish: 'Annatant Règleman',
        finishing: 'Regle...',
        finished: 'Regle',
        order_price: 'Pri Kouran',
        order_cycle: 'Peryòd',
        order_type: 'Tip',
        order_money: 'Kantite',
        order_time: 'Ouvèti',
        order_get: 'Pwofi',
        order_btn: 'Kontinye Komès'
    },
    tradelst: {
        title: 'Lòd Mwen',
        tab1: 'Lòd',
        tab2: 'Konplete',
        tab3: 'Anile',
        usdtnum: ''
    },
    loans: {
        repayment: 'Remèt yon prè',
        title: 'Prè',
        order_tab: 'Lòd Prè',
        pro_tab: 'Pwodwi Prè',
        Institution: 'Enstitisyon Prè',
        Amount: 'Kantite',
        DailyInterest: 'To Enterè pa Jou',
        RepaymentPeriod: 'Peryòd Ranbousman',
        Application: 'Aplike pou Prè',
        orderno: 'No. Lòd',
        AllInterest: 'Total Enterè',
        RepaymentDate: 'Dat Ranbousman',
        RepaymentMethod: 'Metòd Ranbousman',
        Onetime: 'Yon sèl fwa',
        Expected_loan_amount: 'Kantite Prè Espere',
        Expected_loan_amounterror: 'Kantite prè ant {min} - {max}',
        imgplaceholdr: 'Prè Kredi (Asire imaj yo klè)',
        icon1: 'Chaje Devan ID',
        icon2: 'Chaje Dèyè ID',
        icon3: 'Chaje ID nan Men',
        status1: 'Aplikasyon',
        status2: 'Apwouve',
        status3: 'Rejte'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Lòd Mining',
        pro_tab: 'Mache Mining',
        locknum: 'Min Kantite Staking',
        getforday: 'Rannman/Jou',
        days: 'Jou',
        estimation: 'Estimasyon Revni',
        real: 'Touche',
        balance: 'Balans Bous',
        nums: 'Kantite Staking',
        tolockming: 'Stake',
        stime: 'Tan Kòmanse',
        etime: 'Tan Fini'
    },
    transfer: {
        title: 'Transfè Kont',
        searchtxt: 'Antre kont benefisyè',
        ReceivingAccount: 'Enfòmasyon Kont Benefisyè',
        toaccount: 'Kont',
        confirmtxt: 'Klike pou konfime kont benefisyè',
        confirmedtxt: 'Kont benefisyè konfime',
        numtxt: 'Kantite Transfè',
        numerror: 'Antre kantite transfè',
        fee: 'Pa gen frè pou transfè entèn',
        ArrivalTime: 'Tan Arive',
        Immediately: 'Imedyatman',
        realnum: 'Kantite Reyèl Arive',
        btn: 'Konfime Transfè',
        transfering: 'Transfè',
        orderNo: 'No. Lòd',
        stime: 'Tan Transfè',
        etime: 'Tan Arive',
        receiving: 'Kont Benefisyè',
        type: 'Lajan',
        num: 'Kantite Transfè',
        arrivalnum: 'Kantite Resevwa'
    },
    staking: {
        title: 'Staking',
        record: 'Dosye',
        getforyear: 'Estimasyon Rannman Anyèl',
        time: 'Peryòd Envestisman',
        snum: 'Min Envestisman',
        snumerror: 'Antre kantite envestisman',
        snumerror1: 'Min envestisman pa mwens pase {num}',
        join: 'Patisipe Kounye a',
        opentime: 'Tan Ouvèti',
        money: 'Kantite Envestisman',
        days: 'Peryòd',
        recordget: 'Rannman Anyèl',
        gets: 'Revni',
        stime: 'Dat Kòmanse',
        etiem: 'Dat Fini',
        redeemStaking: 'Rachte',
        status0: 'Staking',
        status1: 'Lòd Fini',
        status2: 'Lòd Rachte'
    },
    bank:{
        title: 'Lyen ak kat bankè',
        bankName: 'Non bank lan',
        bankNameError: 'Tanpri antre non bank lan',
        usrName: 'Moun ki gen kat la',
        usrNameError: 'Tanpri antre non moun ki gen kat la',
        cardCode: 'Nimewo kat bankè',
        cardCodeError: 'Tanpri antre nimewo kat la',
        towallet: 'Retire kob nan bous',
        tobank: 'Retire kob nan kat bankè',
        sendcode: 'Voye kòd verification',
        sended: 'Renvoye apre {num} segonn',
        verify_code: 'Tanpri antre kòd verification imèl la'
      }
      
}
